import { render, staticRenderFns } from "./ResumeReview.vue?vue&type=template&id=7db0004e&scoped=true&"
import script from "./ResumeReview.vue?vue&type=script&lang=js&"
export * from "./ResumeReview.vue?vue&type=script&lang=js&"
import style0 from "./ResumeReview.vue?vue&type=style&index=0&id=7db0004e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db0004e",
  null
  
)

export default component.exports